// Modules
import decode from 'jwt-decode'

// Helpers
import { handleStorage, removeNonRequiredDataFromStorage } from 'helpers/system'

// Constants
import { APPLICATION_URL_PATH_PREFIX } from 'constants/environment'

// Helper: Authentication > Check if token is valid
function checkIfTokenIsValid () {
	const storedToken = getToken()
	if (!storedToken?.accessToken || !storedToken?.refreshToken) return false
	else {
		const decodedAccessToken = decode(storedToken.accessToken)
		if (typeof(decodedAccessToken?.exp) !== 'number') return false
		else {
			const remaningTokenTime = decodedAccessToken.exp * 1000 - new Date().getTime()
			if (remaningTokenTime < 0) return false
		}
	}
	return true
}

// Helper: Authentication > Get authorization header
function getAuthorizationHeader () {
	const token = getToken()?.accessToken
	if (!token) console.error('AIX | Authorization header error:', 'Missing token')
	return { Authorization: `Bearer ${token}` }
}

// Helper: Authentication > Get remaining token time
function getRemainingTokenTime (token) {
	const storedToken = token || getToken()
	const decodedAccessToken = decode(storedToken.accessToken)
	return decodedAccessToken.exp * 1000 - new Date().getTime()
}

// Helper: Authentication > Get team
function getTeam () {
	const team = handleStorage('get', 'team')
	return team ? Number(team) : null
}

// Helper: Authentication > Get team header
function getTeamHeader () {
	const team = getTeam()
	if (!team) console.error('AIX | Team header error:', 'Missing team id')
	return { 'x-team': team }
}

// Helper: Authentication > Get token
function getToken () {
	const token = handleStorage('get', 'token')
	return token ? JSON.parse(token) : null
}

// Helper: Authentication > Logout
function logout ({ willIncludeRedirectURL = true } = {}) {
	const storedRedirectURL = localStorage.getItem('redirectURL')
	removeNonRequiredDataFromStorage()
	window.dataLayer.push({ event: 'account-logout' })
	let url = window.location.origin
	if (!!APPLICATION_URL_PATH_PREFIX) url += APPLICATION_URL_PATH_PREFIX
	if (willIncludeRedirectURL && !!storedRedirectURL) url += `?redirect_url=${storedRedirectURL}`
	window.location.href = url
}

// Helper: Authentication > Remove team
function removeTeam () {
	handleStorage('remove', 'team')
}

// Helper: Authentication > Remove token
function removeToken () {
	handleStorage('remove', 'token')
}

// Helper: Authentication > Store team
function storeTeam (teamId) {
	handleStorage('set', 'team', teamId)
}

// Helper: Authentication > Store token
function storeToken (token) {
	handleStorage('set', 'token', JSON.stringify(token))
}

// Export
export {
	checkIfTokenIsValid,
	getAuthorizationHeader,
	getRemainingTokenTime,
	getTeam,
	getTeamHeader,
	getToken,
	logout,
	removeTeam,
	removeToken,
	storeTeam,
	storeToken
}
